// src/utils/platform.js

// Detect if running in Electron
export const isElectron = () => {
  // Check if window.process exists and has electron type
  if (typeof window !== 'undefined' && window.process && window.process.type) {
    return true;
  }
  
  // Check if navigator.userAgent contains Electron
  if (typeof navigator === 'object' && 
      typeof navigator.userAgent === 'string' && 
      navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }
  
  // Check if electronAPI is exposed
  if (typeof window !== 'undefined' && window.electronAPI) {
    return true;
  }
  
  return false;
};

export const getPlatform = () => {
  return isElectron() ? 'desktop' : 'web';
};

// Open URL in external browser (for Electron)
export const openInBrowser = (url) => {
  if (isElectron() && window.electronAPI?.openExternal) {
    window.electronAPI.openExternal(url);
  } else {
    window.open(url, '_blank');
  }
};